import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DataContext = createContext(null);

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (!context) {
    // Return default context if not wrapped in provider (for testing)
    return { 
      context: 'business', 
      setContext: () => {},
      apiPrefix: '/api',
      collectionPrefix: '',
      contextLabel: 'Business'
    };
  }
  return context;
};

export function DataContextProvider({ children }) {
  const location = useLocation();
  const [context, setContext] = useState('business');
  
  // Auto-detect context from URL path
  useEffect(() => {
    if (location.pathname.startsWith('/personal')) {
      setContext('personal');
    } else if (location.pathname.startsWith('/business')) {
      setContext('business');
    }
  }, [location.pathname]);
  
  // Generate API prefix based on context
  const apiPrefix = context === 'personal' ? '/api/personal' : '/api/business';
  
  // Collection prefix for backend
  const collectionPrefix = context === 'personal' ? 'personal_' : 'business_';
  
  // Human-readable label
  const contextLabel = context === 'personal' ? 'Personal' : 'Business';
  
  const value = {
    context,
    setContext,
    apiPrefix,
    collectionPrefix,
    contextLabel,
    isPersonal: context === 'personal',
    isBusiness: context === 'business',
  };
  
  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}

export default DataContext;
